angular.module('leave')
    .directive('leaveTypeCategoryPicker', function (LeaveTypeService) {
        return {
            restrict: 'E',
            require: 'ngModel',
            replace: true,
            scope: {
                required: "=",
            },
            template: `
                <div>
                    <select class="form-control input-sm" ng-model="selected" ng-change="onChange(selected)" title="{{ 'leave-type.category' | translate}}" ng-required="required">
                        <option value="">{{ 'leave-type.category.select' | translate}}</option>
                        <option ng-value="item" ng-repeat="item in items">{{ 'leave-type.category.'+item | translate}}</option>
                    </select>
                </div>
            `,
            link: function (scope, $element, $attrs, ngModelCtrl) {

                scope.items = LeaveTypeService.categories()
                ngModelCtrl.$render();

                scope.onChange = value => {}

                ngModelCtrl.$render = () => {
                    scope.selected = ngModelCtrl.$viewValue

                    if (scope.selected && scope.items) {
                        let elemExists = scope.items
                            .find(it => it === scope.selected)

                        if (elemExists) {
                            scope.selected = elemExists
                        } else {
                            let custom = scope.selected
                            scope.items.push(custom)
                            scope.selected = custom
                        }
                    }
                };
                ngModelCtrl.$formatters.push(modelValue => modelValue)
                ngModelCtrl.$parsers.push(viewValue => viewValue)

                scope.$watch('selected', () => {
                    ngModelCtrl.$setViewValue(scope.selected)
                    ngModelCtrl.$validate()
                    ngModelCtrl.$render()
                })
            }
        }
    })
